import { defineMessages } from 'react-intl';

export default defineMessages({
  comparisonLabel: {
    id: 'chartLabel.comparison',
    description: 'comparison',
    defaultMessage: 'Comparison',
  },
  comparisonDescription: {
    id: 'chartLabel.comparisonDescription',
    description: 'SUGGESTED VS. SELECTED COMPARISON CHART',
    defaultMessage: 'SUGGESTED VS. SELECTED COMPARISON CHART',
  },
  pipelineLabel: {
    id: 'chartLabel.pipeline',
    description: 'pipeline',
    defaultMessage: 'Pipeline',
  },
  pipelineDescription: {
    id: 'chartLabel.pipelineDescription',
    description: 'PIPELINE AND PRICE BAND COMPARISON',
    defaultMessage: 'PIPELINE AND PRICE BAND COMPARISON',
  },
  competitionLabel: {
    id: 'chartLabel.competition',
    description: 'competition',
    defaultMessage: 'Competition',
  },
  competitionDescription: {
    id: 'chartLabel.competitionDescription',
    description: 'COMPETITIVE LANDSCAPE',
    defaultMessage: 'COMPETITIVE LANDSCAPE',
  },
  advancedLabel: {
    id: 'chartLabel.advanced',
    description: 'Advanced',
    defaultMessage: 'Advanced',
  },
  advancedDescription: {
    id: 'chartLabel.advancedDescription',
    description: 'ADVANCED PIPELINE ANALYSIS',
    defaultMessage: 'ADVANCED PIPELINE ANALYSIS',
  },
});
